export default __webpack_public_path__ + "static/media/hamburger.7185994d.svg";